import { BaseService } from './core/BaseService';
import { Model } from '../types';

export interface GenerateRequest {
    modelId?: string;
    prompt?: string;
    mode?: string;
    inputImage?: string;
    inputImages?: string[];
    params?: Record<string, any>;
}

export interface GenerateResult {
    taskId: string;
    status: string;
    results?: Array<{ url: string; outputType: string; base64?: string }>;
    error?: string;
    videoMetadata?: Record<string, any>;
    analysis?: string;
}

export interface TaskStatusResult {
    taskId: string;
    status: 'pending' | 'running' | 'success' | 'failed' | 'cancelled';
    result?: any;
    error?: string;
    traceback?: string;
}

class GenerateApiService extends BaseService {
    async getModels(): Promise<Model[]> {
        const data = await this.get('/api/models');
        return (data as any).models || [];
    }

    async generateSync(request: GenerateRequest): Promise<GenerateResult> {
        return this.post<GenerateResult>('/api/generate/sync', request);
    }

    async generateAsync(request: GenerateRequest): Promise<{ taskId: string; status: string; message: string; image?: string; videoUri?: string; audioUri?: string; analysis?: string }> {
        return this.post<{ taskId: string; status: string; message: string; image?: string; videoUri?: string; audioUri?: string; analysis?: string }>('/api/generate', request);
    }

    async getTaskStatus(taskId: string): Promise<TaskStatusResult> {
        return this.get<TaskStatusResult>(`/api/task/${taskId}/status`);
    }

    async cancelTask(taskId: string): Promise<void> {
        await this.post(`/api/cancel/${taskId}`);
    }

    async pollTaskUntilComplete(
        taskId: string,
        onProgress?: (status: TaskStatusResult) => void,
        maxAttempts: number = 360,
        interval: number = 5000,
    ): Promise<TaskStatusResult> {
        for (let i = 0; i < maxAttempts; i++) {
            const status = await this.getTaskStatus(taskId);
            onProgress?.(status);

            if (status.status === 'success' || status.status === 'failed' || status.status === 'cancelled') {
                return status;
            }

            await new Promise(r => setTimeout(r, interval));
        }

        throw new Error('任务轮询超时');
    }
}

export const generateApi = new GenerateApiService();
